module.exports = __webpack_public_path__ + "media/images/top/img_tab_chariloto_3-90658f40ae1bb8a594bf03ef7fe77439.png";